import * as React from "react"
import styled from "@emotion/styled"
import { theme, rr } from "../../styles/styleGuide"
import Svg from "../../assets/mobile/svg/skills.inline.svg"
import Ps from "../../assets/mobile/svg/Ps.inline.svg"
import Ai from "../../assets/mobile/svg/Ai.inline.svg"
import Xd from "../../assets/mobile/svg/Xd.inline.svg"
import Re from "../../assets/mobile/svg/React.inline.svg"
import Ga from "../../assets/mobile/svg/Gatsby.inline.svg"
import Ts from "../../assets/mobile/svg/Ts.inline.svg"
import Gs from "../../assets/mobile/svg/Gsap.inline.svg"
import Lo from "../../assets/mobile/svg/Lotty.inline.svg"
import Ht from "../../assets/mobile/svg/Html.inline.svg"
import Ae from "../../assets/mobile/svg/Ae.inline.svg"
import Pr from "../../assets/mobile/svg/Pr.inline.svg"
import Me from "../../assets/mobile/svg/Me.inline.svg"
import Css from "../../assets/mobile/svg/css.inline.svg"
import Mjml from "../../assets/mobile/svg/mjml.inline.svg"
import desVid from "../../assets/mobile/videos/skillsDesignMobile.mp4"
import devVid from "../../assets/mobile/videos/skillsDevelopmentMobile.mp4"
import emailVid from "../../assets/mobile/videos/skillsEmailMobile.mp4"
import animVid from "../../assets/mobile/videos/skillsAnimationMobile.mp4"
import motionVid from "../../assets/mobile/videos/skillsMotionMobile.mp4"
var color = theme.color,
  font = theme.font,
  iconCol1 = [
    {
      icon: Ps,
      left: 50,
      color: color.skills.design,
    },
    {
      icon: Re,
      left: 75,
      color: color.skills.development,
    },
    {
      icon: Mjml,
      left: 75,
      color: color.skills.email,
    },
    {
      icon: Gs,
      left: 70,
      color: color.skills.animation,
    },
    {
      icon: Ae,
      left: 50,
      color: color.skills.motion,
    },
  ],
  iconCol2 = [
    {
      icon: Pr,
      left: 20,
      color: color.skills.motion,
    },
    {
      icon: Lo,
      left: 50,
      color: color.skills.animation,
    },
    {
      icon: Ht,
      left: 20,
      color: color.skills.email,
    },
    {
      icon: Ga,
      left: 20,
      color: color.skills.development,
    },
    {
      icon: Ai,
      left: 10,
      color: color.skills.design,
    },
  ],
  iconCol3 = [
    {
      icon: Xd,
      left: 70,
      color: color.skills.design,
    },
    {
      icon: Ts,
      left: 50,
      color: color.skills.development,
    },
    {
      icon: Css,
      left: 50,
      color: color.skills.email,
    },
    {
      icon: Ht,
      left: 20,
      color: color.skills.animation,
    },
    {
      icon: Me,
      left: 70,
      color: color.skills.motion,
    },
  ],
  description = {
    design:
      "Building an eye-catching design and Having the best user experience is my target as a web designer, so I follow design trends, do sequential user flow researches, and use Powerful designing tools.",
    development:
      "My goal as a front-end developer is to convert the design into high-quality code, so I use React, Gatsby, and Typescript for building responsive high-speed websites.",
    animation:
      "Animation brings life to the website, I use GSAP, Lotty-web, and HTML5-canvas to create seamless transitions and interactive elements, helping users to easily understand and interact with the website.",
    motion:
      "Cool designers use images. The Coolest use videos, Creating motion graphics and video effects is one of my favorite skills, I use Adobe AfterEffecs, and  PremierPro to build creative videos and animations.",
    email:
      "Email is the best engagement method between clients and businesses, so it has to be attractive and user-friendly, I use MJML, HTML, and CSS to build Custom designed email templates that work in all email services and responsive to all devices.",
  }

function Skills() {
  return (
    <Container id="skills">
      <Clip className="clip">
        <SlideContainer>
          <Video src={motionVid} className="motion" />
          <Video src={animVid} className="animation" />
          <Video src={emailVid} className="email" />
          <Video src={devVid} className="development" />
          <Video src={desVid} className="design" />
          <Slide
            id="design-slide"
            title={{ upper: "ux/ui", lower: "design" }}
            Color={color.skills.design}
            description={description.design}
          />
          <Slide
            id="development-slide"
            title={{ upper: "front-end", lower: "development" }}
            Color={color.skills.development}
            description={description.development}
          />
          <Slide
            id="email-slide"
            title={{ upper: "email", lower: "templates" }}
            Color={color.skills.email}
            description={description.email}
          />
          <Slide
            id="animation-slide"
            title={{ upper: "animation &", lower: "interactions" }}
            Color={color.skills.animation}
            description={description.animation}
          />
          <Slide
            id="motion-slide"
            title={{ upper: "motion", lower: "graphics" }}
            Color={color.skills.motion}
            description={description.motion}
          />

          <Icons />
        </SlideContainer>
        <Border className="border" />
      </Clip>
      <Title />
    </Container>
  )
}
const Container = styled.div`
  position: absolute;
  bottom: 0;
  width: 100vw;
  ${rr("height", "vh", 91.4)}
  overflow: hidden;
`
const Border = styled.div`
  position: absolute;
  pointer-events: none;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100%;
  ${rr("border", ` solid ${color.skills.cover.background}`, "2.4vw", "2.4vw", "2.1vw")}
  box-sizing: border-box;
`
const Clip = styled.div`
  height: 100%;
  width: 100%;
  clip-path: inset(0% 0% 0% 0%);
  background-color: ${color.skills.cover.primary};
`
const Title = () => {
  const Text = styled.div`
    #skills-title-svg {
      position: absolute;
      top: 52%;
      left: 50%;
      transform: translate(-50%, -50%);
      height: 65%;
      .cls-1 {
        fill: ${color.skills.design.primary};
      }

      .cls-2 {
        ${rr("stroke-width", "vw", 0.7, 0.7, 0.4)}
        stroke: ${color.skills.design.background};
        fill: none;
      }

      .cls-3 {
        fill: ${color.skills.design.background};
      }
    }
  `
  const Border = styled.div`
    position: absolute;
    box-sizing: border-box;
    width: 100vw;
    height: 12%;
    top: 0;
    left: 0;
    background-color: ${color.skills.design.primary};
  `

  return (
    <Border className="section-title">
      <Text>
        <Svg />
      </Text>
    </Border>
  )
}
interface slide {
  title: {
    upper: string
    lower: string
  }
  description: string
  Color: { primary: string; secondary: string; background: string }
  id: string
}
const Slide: React.FC<slide> = ({ title, Color, description, id }) => {
  const Title = () => {
    const Split = (text: string) => {
      const Figure = styled.span`
        display: inline-block;
        color: inherit;
        -webkit-text-stroke: inherit;
        font-size: inherit;
        margin: 0;
        ${font.title};
      `
      return text.split("").map((e: string, key: number) => (
        <Figure className="figure" key={key}>
          {e}
        </Figure>
      ))
    }
    const Upper = styled.h1`
      margin: 0;
      line-height: 0.9;
      color: ${Color.primary};
      overflow: hidden;
    `
    const Lower = styled(Upper)`
      ${rr("-webkit-text-stroke", ` ${Color.secondary}`, "0.3vw", "0.3vw", "0.28vw")}
      color:transparent;
    `
    const Holder = styled.div`
      ${rr("font-size", "em", 1.9, 1.8, 1.7)}
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
    `
    return (
      <Holder className="title">
        <Upper className="upper"> {Split(title.upper)}</Upper>
        <Lower className="lower"> {Split(title.lower)}</Lower>
      </Holder>
    )
  }
  const Description = () => {
    const Text = styled.p`
      ${rr("font-size", "em", 1.1, 1, 1)}
      color: ${Color.primary};
      ${font.content.medium};
      /* margin-top: 5.2em; */
      ${rr("margin-top", "vh", 6.5, 7.5, 8.5)}
      width: 83vw;
    `
    return <Text className="description">{description}</Text>
  }
  // const Video = () => {
  //   const Video = styled.video`
  //     position: absolute;
  //     ${rr("bottom", "vh", -0, -10, -20)}
  //     z-index: -1;
  //     width: 100vw;
  //     /* background-color: #00ff40; */
  //   `
  //   return <Video className={`${id}-video`} src={video} muted autoPlay loop playsInline />
  // }
  const SlideHolder = styled.div`
    position: absolute;
    ${rr("top", "vh", 20, 20, 18)}
    left: 9vw;
    ${rr("font-size", "vw", 4.2, 4.2, 3.5)}
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  `
  return (
    <>
      <SlideHolder id={id}>
        <Title />
        <Description />
      </SlideHolder>
    </>
  )
}
const Icons = () => {
  interface iconsRow {
    icons: {
      icon: string
      left: number
      color: { secondary: string; background: string }
    }[]
    left?: number
    right?: number
    index: number
  }
  const IconsRow: React.FC<iconsRow> = ({ icons, left, right, index }) => {
    interface icon {
      icon: {
        icon: string
        left: number
        color: { secondary: string; background: string }
      }
    }
    const Icon: React.FC<icon> = ({ icon }) => {
      const Icon = styled.div`
        position: relative;
        width: 100vw;
        display: block;
        z-index: 2;
        /* background-color: ${icon.color.secondary}; */
        .icon {
          position: relative;
          left: ${icon.left}vw;
          ${rr("width", "vw", 9, 9, 8)}
          path {
            fill: ${icon.color.secondary};
            stroke: none;
          }
        }
      `
      const LineBackground = styled.div`
        position: absolute;
        left: ${icon.left}vw;
        top: 45%;
        transform: translate(-20%);
        width: 15%;
        height: 8%;
        background-color: ${icon.color.background};
      `
      return (
        <Icon>
          <LineBackground className="icon-back-line" />
          <icon.icon />
        </Icon>
      )
    }
    const Line = styled.div`
      position: absolute;
      width: 100%;
      height: 1%;
      background-color: ${color.skills.design.primary};
    `
    const Holder = styled.div`
      position: relative;
      display: flex;
      flex-direction: row;
      align-items: center;
      left: ${left}vw;
      right: ${right}vw;
      height: 10vh;
      ${rr("height", "vh", 7, 8, 9)}
    `
    return (
      <Holder className={`icon-row-${index}`}>
        <Line className="icons-connect-lines" />
        <Icon icon={icons[0]} />
        <Icon icon={icons[1]} />
        <Icon icon={icons[2]} />
        <Icon icon={icons[3]} />
        <Icon icon={icons[4]} />
      </Holder>
    )
  }
  const IconsRowHolder = styled.div`
    position: absolute;
    left: 0vw;
    ${rr("bottom", "vh", 4, 3, 4)}
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  `

  return (
    <IconsRowHolder className="icon-rows-holder">
      <IconsRow icons={iconCol1} left={0} index={0} />
      <IconsRow icons={iconCol2} right={400} index={1} />
      <IconsRow icons={iconCol3} left={0} index={2} />
    </IconsRowHolder>
  )
}
interface video {
  src: string
  className: string
}
const Video: React.FC<video> = ({ src, className }) => {
  const Video = styled.video`
    position: absolute;
    width: 100vw;
    ${rr("bottom", "vh", -0, -10, -20)}
  `
  return <Video src={src} className={className} loop muted autoPlay playsInline />
}
const SlideContainer = styled.div`
  position: absolute;
  width: 100vw;
  height: 100%;
  overflow: hidden;
`

export default Skills
